<template>
    <v-layout row justify-center>
        <v-dialog :value="show" persistent max-width="500">
            <v-card>
                <v-card-title class="warning headline white--text">
                    {{ $t(`${errorKey}.title`) }}
                </v-card-title>
                <v-card-text class="text-center pt-3" v-html="$t(`${errorKey}.message`, replacements)" />
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="warning" text @click="$emit('close')">
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>

import { noop } from 'lodash';

export default {
    name: 'error-modal',
    props: {
        show: { type: Boolean, required: true },
        errorKey: { type: String, required: true },
        replacements: { type: Object, required: false, default: noop() },
    },
};
</script>
